module.exports = __webpack_public_path__ + "img/grid.24eb207d.svg";